export default __webpack_public_path__ + "static/media/12-3.5d1c79ef.mp3";